/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["custom-page{display:block;height:100%;width:100%;flex:1 1 auto;overflow:auto}custom-page>.page-body{padding:25px}"];
export { styles as styles };
